import slice from './slice';

export const { 
  resetState,
  setSelectedDrone,
  toggleCollapse, 
  setMapLocation,
  resetMapLocation,
  setShowTakeoffConfirm,
  setMissionId,
  setHoveredDrone,
  setManualControl,
  addOptimisticMissionSerial,
  removeOptimisticMissionSerials,
  addEndedMissionSerial,
  removeEndedMissionSerials,
} = slice.actions;

export default slice.reducer;
